<template>
    <div class="assess">
    <!-- 头部 -->
    <headers :title="'服务项目验收表'"/>
    <!--  -->
    <div class="assess-container">
        <div style="padding: 6px 4px">
            <table class="table table-bordered">

                <thead>
                    <tr>
                        <td style="text-align: left">顾客名称：
                            <span id="CustomerName">{{CustomerName}}</span>
                        </td>
                        <td style="text-align: left">联系电话：
                            <span id="CustomerPhone">{{CustomerPhone}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left">服务项目：
                            <span id="ServiceName">{{ServiceName}}</span>
                        </td>
                        <td style="text-align: left">服务总价：
                            <span id="Amount"></span>{{Amount}}元</td>
                    </tr>
                </thead>
            </table>
            <table class="table table-bordered" style="border-top: 0px;">
                <tbody style="border-right: 0px">
                    <tr style="border-right: 0px">
                        <td style="border-top: 0px; width: 50%; border-right: 0px">
                            <label for="ok" style="font-size: 16px;">合格</label>
                            <input type="radio" id="ok" name="assess" value="合格" v-model="CustomerResult"/>
                        </td>
                        <td style="border-top: 0px;width: 50%;border-left: 0px">
                            <label for="fault" style="font-size: 16px; ">不合格</label>
                            <input type="radio" id="fault" name="assess" value="不合格" v-model="CustomerResult"/>
                        </td>

                    </tr>
                </tbody>
            </table>
            <table class="table table-bordered" style="border-top: 0px;">
                <tbody style="border-top: 0px;">
                    <tr style="border-top: 0px;">
                        <td style="width: 30%;border-right: 1px solid #ddd; border-top: 0px;padding: 14px">服务态度</td>
                        <td style="width: 70%; border-top: 0px;">
                            <div class="rating attitude">
                                <input type="radio" id="att5" name="rating1" value="5" hidden v-model="ResultA"/>
                                <label for="att5"></label>
                                <input type="radio" id="att4" name="rating1" value="4" hidden v-model="ResultA"/>
                                <label for="att4"></label>
                                <input type="radio" id="att3" name="rating1" value="3" hidden v-model="ResultA"/>
                                <label for="att3"></label>
                                <input type="radio" id="att2" name="rating1" value="2" hidden v-model="ResultA"/>
                                <label for="att2"></label>
                                <input type="radio" id="att1" name="rating1" value="1" hidden v-model="ResultA"/>
                                <label for="att1"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 30%;border-right: 1px solid #ddd;  padding: 14px">专业技能</td>
                        <td style="width: 70%;">
                            <div class="rating skill">
                                <input type="radio" id="skill5" name="rating2" value="5" hidden v-model="ResultB"/>
                                <label for="skill5"></label>
                                <input type="radio" id="skill4" name="rating2" value="4" hidden v-model="ResultB"/>
                                <label for="skill4"></label>
                                <input type="radio" id="skill3" name="rating2" value="3" hidden v-model="ResultB"/>
                                <label for="skill3"></label>
                                <input type="radio" id="skill2" name="rating2" value="2" hidden v-model="ResultB">
                                <label for="skill2"></label>
                                <input type="radio" id="skill1" name="rating2" value="1" hidden v-model="ResultB"/>
                                <label for="skill1"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 30%;border-right: 1px solid #ddd; padding: 14px">清洁质量</td>
                        <td style="width: 70%;">
                            <div class="rating quality">
                                <input type="radio" id="qua5" name="rating3" value="5" hidden v-model="ResultC"/>
                                <label for="qua5"></label>
                                <input type="radio" id="qua4" name="rating3" value="4" hidden v-model="ResultC"/>
                                <label for="qua4"></label>
                                <input type="radio" id="qua3" name="rating3" value="3" hidden v-model="ResultC"/>
                                <label for="qua3"></label>
                                <input type="radio" id="qua2" name="rating3" value="2" hidden v-model="ResultC"/>
                                <label for="qua2"></label>
                                <input type="radio" id="qua1" name="rating3" value="1" hidden v-model="ResultC"/>
                                <label for="qua1"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 30%;border-right: 1px solid #ddd; padding: 14px">顾客意见或建议</td>
                        <td style="width: 70%;">
                            <textarea name="user-remark" cols="30" rows="10" style="height: 60px;border: 0;width:100%;" class='user-remark' v-model="ResultRemarks"></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tabbtn">
            <a href="tel:4001500600" class="servicetel-btn">
                <img src="http://www.lungchuenjz.cn/images/kefu_tel.png" style="width: 20px;"> 客服
            </a>
            <div class="submit-btn" @click="confirm">
                提交评价
            </div>
            


        </div>
    </div>
    <!--  -->

    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    data () {
        return{
            CustomerName:'',
            CustomerPhone:'',
            ServiceName:'',
            Amount:'',
            CustomerResult:'',
            ResultA:'',
            ResultB:'',
            ResultC :'',
            ResultRemarks:'',
            OfferId:'',
            OrderId:''
        }
    },
    mounted () {
        this.$axios.get('/api/DjOrder/GetOfferResultInfo',{
            params: {
                 Id: this.$route.query.Id,
            }
        }).then(res => {
            let data = res.data
            this.CustomerName = data.CustomerName
            this.CustomerPhone = data.CustomerPhone
            this.ServiceName = data.ServiceName
            this.Amount = data.Amount
            this.OfferId = data.OfferId
            this.OrderId = data.OrderId
        })
    },
    methods:{
        confirm () {
            if (!this.CustomerResult || !this.ResultA || !this.ResultB || !this.ResultC) {
                Toast.fail('请为本次服务项目评价');
                return
            }
            this.$axios.post('/api/DjOrder/SaveOfferResult',{
             OrderId: this.OrderId,
             OfferId: this.OfferId,
             CustomerResult: this.CustomerResult,
             ResultA: this.ResultA,
             ResultB: this.ResultB,
             ResultC: this.ResultC,
             ResultRemarks: this.ResultRemarks
            }).then(res => {
                let data = res.data
                if (data.type == 1) {
                    this.$router.replace('/orderlist')
                } else {
                    Toast.fail(data.message);
                }
            })
        }
    }
}
</script>

<style scoped>
.assess {
    box-shadow: 0 0 0;
    background: #fff;
}

.m-navbar {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 49;
    width: 100%;
}

.assess-container {
    margin-top: 40px;
    background-color: #fff;

    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    flex-wrap: wrap;

}

.assess-container p {
    width: 50%;
    height: px;
    display: flex;
    padding: 8px;
    justify-content: flex-start;
    border: 1px solid #ddd;
    align-items: center;
}

input[type="radio"] {
    -webkit-appearance: radio;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    padding: 4px;
    zoom: 100%;
    margin-right: 4px;
}

.asssess-checkbox {

    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 98%;
    height: 46px;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    margin: 0 auto;
}

.table {
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}


.table>tbody>tr>td,
.table>thead>tr>td,
.table>tfoot>tr>td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
    width: 25%;
    font-size: 14px;
    text-align: center;
}

.table-bordered {
    border: 1px solid #ddd;
}

.table-bordered>tbody>tr>td,
.table>thead>tr>td {
    border: 1px solid #ddd;
}

.rating {
    font-size: 0;
    width: 80%;

    display: table;
}

.rating>label {
    color: #ddd;
    float: right;
}

.rating>label:before {
    padding: 5px;
    font-size: 24px;
    line-height: 1em;
    display: inline-block;
    content: "★";
}

.rating>input:checked~label,
.rating:not(:checked)>label:hover,
.rating:not(:checked)>label:hover~label {
    color: #FFD700;
}


.tabbtn {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 40px;
    background-color: #fff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #fff;
}

.submit-btn {
    width: 80%;
    height: 40px;
    color: #fff;
    background-color: rgb(185, 40, 40);
    text-align: center;
    line-height: 40px;
    font-size: 14px;
}

.servicetel-btn {
    background-color: #009933;
    width: 20%;
    font-size: 14px;
    height: 40px;
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderList/Assess.vue